<div class="container" [class.directPayment]="context === Context.Customer">
  <ng-casto-payment-contribution-choices *ngIf="step === 1" [step]="step" [maxStep]="2" [isColleague]="false"
    [labelCancel]="'Annuler'" [labelSave]="'Continuer'" (save)="choosePayment($event)"
    (cancel)="goToCustomerCard(false)"></ng-casto-payment-contribution-choices>

  <ng-casto-finalization-creation *ngIf="step === 2" [paytweakPayload]="paytweakPayload" [paymentMethod]="paymentMethod"
    [context]="context" [labelSave]="'Fermer'" (finish)="goToCustomerCard(true)"></ng-casto-finalization-creation>
</div>